(function () {
  var BADGE_SELECTOR =
    ".ProductMeta__Label.ProductMeta__Label--metafield, .ProductItem__Label.ProductItem__Label--metafield, .Product__Badge.Product__Badge--metafield";

  function revealBadge(badge) {
    badge.classList.add("ProductBadge--visible");
    badge.setAttribute("data-badge-observed", "true");
  }

  function observeBadge(badge, observer) {
    if (badge.getAttribute("data-badge-observed") === "true") return;
    if (!observer) {
      revealBadge(badge);
      return;
    }
    observer.observe(badge);
  }

  function initBadgeObserver() {
    var badges = document.querySelectorAll(BADGE_SELECTOR);
    if (!badges.length) return;

    var observer = null;

    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            revealBadge(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          root: null,
          threshold: 0.05,
          rootMargin: "0px 0px -5% 0px"
        }
      );
    }

    badges.forEach(function (badge) {
      observeBadge(badge, observer);
    });

    var mutationObserver = new MutationObserver(function () {
      document.querySelectorAll(BADGE_SELECTOR).forEach(function (badge) {
        observeBadge(badge, observer);
      });
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBadgeObserver);
  } else {
    initBadgeObserver();
  }
})();
